export default "__VITE_ASSET__36e7f95c__"